export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const HAS_LOGGEDIN_FOR_FIRST_TIME = "HAS_LOGGEDIN_FOR_FIRST_TIME";
